import React, { useState } from "react";
// import { Button, Modal } from "react-bootstrap";
import Modal from "../Modal/Modal";
import FormField from "../FormField/FormField";
import ConfirmButton from "../Buttons/ConfirmButton";
import CancelButton from "../Buttons/CancelButton";
import { notify } from "react-notify-toast";
import "../../Components-Pages/Resume/Resume.css";

import { Link } from "react-router-dom";
import { API } from "../../API";
const PROFILE_URL = `https://www.readyteacherapp.com/NavigateToCollegeSharedProfile?id=`;
function PopUp(props) {
  // debugger;
  const [message, setMessage] = useState(
    "I thought you might be interested in viewing this profile."
  );
  const [email, setEmail] = useState();
  const [name, setName] = useState();

  const handleClose = () => {
    props.showPopup(false);
  };

  const copyToClipboard = (e, elementId) => {
    e.preventDefault();
    var aux = document.createElement("input");

    // Assign it the value of the specified element
    aux.setAttribute("value", document.getElementById(elementId).innerHTML);

    // Append it to the body
    document.body.appendChild(aux);

    // Highlight its content
    aux.select();

    // Copy the highlighted text
    document.execCommand("copy");

    // Remove it from the body
    document.body.removeChild(aux);
  };

  const shareProfile = (event) => {
    event.preventDefault();

    let msg = message;
    msg.replace("\n", "\r\n");
    API.updateShareCollegeProfile({
      id: props.institution._id,
      to: email,
      msg: msg,
      FName: name,
    })
      .then((res) => {
        notify.show("Profile shared successfully");
        setEmail("");
        setMessage("");
      })
      .catch((err) => {
        console.log(err);
      });
    props.showPopup(false);
  };

  const [showShareForm, setShowShareForm] = useState(false);

  const displayShareForm = () => {
    if (showShareForm === false) {
      document.getElementById("email-share-form").style.display = "block";
      // document.getElementById("showShareForm").style.display = "none";
      setShowShareForm(true);
    }
    if (showShareForm === true) {
      document.getElementById("email-share-form").style.display = "none";
      setShowShareForm(false);
    }
  };

  const ShareProfilePopup = () => {
    return (
      <Modal
        show={true}
        className="share-profile-modal-new"
        header="Share Profile"
        onClose={handleClose}
      >
        {!props.isShared && (
          <div className="row mb-4 d-flex justify-content-between">
            <div className="col-12 m-auto">
              <p className=" mb-0 px-0 button-in-share-group">
                {/* <span>Preview Your Profile</span>*/}
                <Link
                  className="mdi mdi-file-find-outline preview-profile-link-in-share"
                  to={{
                    // pathname: `/NavigateToCollegePreviewProfile?id=${props.institution._id}`,
                    pathname: "/CollegePreviewProfile",
                  }}
                  target="_blank"
                >
                  Preview
                </Link>
              </p>
            </div>
          </div>
        )}

        <div className="row mb-4 d-flex justify-content-between">
          <div className="col-12 m-auto">
            <p className=" mb-0 px-0 button-in-share-group">
              {/*         <span>Copy link</span>*/}
              <span id={"lnkProfile" + props.institution._id} class="d-none">
                {PROFILE_URL + props.institution._id}
              </span>
              <Link
                className="mdi mdi-link-variant preview-profile-link-in-share"
                to={{}}
                onClick={(e) => {
                  copyToClipboard(e, "lnkProfile" + props.institution._id);
                  notify.show("Link copied to clipboard");
                }}
              >
                Copy Link
              </Link>
              {/* TODO: when user clicks here, the link is copied */}
            </p>
          </div>
        </div>
        <div className="row mb-4 d-flex justify-content-between">
          <div className="col-12 m-auto">
            <p className=" mb-0 px-0 button-in-share-group">
              {/* <span>Preview Your Profile</span>*/}
              <p
                className="mdi mdi-email-outline preview-profile-link-in-share"
                onClick={displayShareForm}
              >
               Share via Email
              </p>
            </p>
          </div>
        </div>
        <div className="row link-icon-group-style">
          <div className="col-12 link-profile-button-in-share button-in-share-group-1">
            {/* <div
                    id="showShareForm"
                    className="col-auto email-shareprofile shareprofile"
                    onClick={displayShareForm}
                  >
                    <icon className="mdi mdi-email-outline"></icon>
                  </div> */}
            <div className="col-auto m-auto linkedin-shareprofile shareprofile">
              <icon className="mdi mdi-linkedin"></icon>
            </div>
            <div className="col-auto m-auto facebook-shareprofile shareprofile">
              <icon className="mdi mdi-facebook"></icon>
            </div>
            <div className="col-auto m-auto twitter-shareprofile shareprofile">
              <icon className="mdi mdi-twitter"></icon>
            </div>
          </div>
        </div>

        <form
          id="email-share-form"
          onSubmit={(e) => {
            shareProfile(e);
          }}
        >
          <div className="row">
            <div className="col-12">
              <FormField
                type="textarea"
                rows="3"
                id="message"
                placeholder={
                  "I thought you might be interested in viewing this profile."
                }
                onChange={(e) => setMessage(e.target.value)}
                value={message}
                required
              />

              <FormField
                name="name"
                id="name"
                placeholder="Recipient's name"
                required
                value={name}
                onChange={(e) => setName(e.target.value)}
              />

              <FormField
                icon="email"
                name="email"
                id="email"
                placeholder="Recipient's email"
                autoFocus
                required
                value={email}
                onChange={(e) => setEmail(e.target.value)}
              />
            </div>
          </div>
          <div className="row">
            <div className="col-md-6">
              <CancelButton onClick={handleClose}>Cancel</CancelButton>
            </div>
            <div className="col-md-6">
              <ConfirmButton type="submit">Share</ConfirmButton>
            </div>
          </div>
        </form>
      </Modal>
    );
  };
  return <>{props.formType === "shareProfile" && ShareProfilePopup()}</>;
}
export default PopUp;
